module.exports = __webpack_public_path__ + "img/26.c11cda9d.jpg";